import React, {useEffect, useState} from 'react'
import {history} from "../../configureHistory";
import Button from '../atoms/button/button';
import {orderStatuses} from "../constants/orderStatuses";
import {t} from "../../i18n";
import {ai} from "../../TelemetryService";
import { getOptionText } from "./DeliveryOption.container";
export default class Register extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        let state = props.location.state;
        this.state = {
            a: 0,
            code: state && state.code,
            b: 0,
            pType: 0,
            pageType: 0,
            passD: this.props.feed,
            preview : false,
            status: this.props.feed.OrderStatus,
            isLogged: false,
            text: this.props.feed.CarPlate || "",
            intervalToCancel:0,
            timeoutToCancel:0,
            showSuccess:false,
            storeId:0
        };
        //window.history.replaceState(null, '', `/${this.state.code}`);
        if(state && state.preview){
            this.state = {
                a: 0,
                code: props.location.state.code,
                b: 0,
                pType: 0,
                pageType: props.location.state.pageType || 0,
                preview: props.location.state.preview,
                isLogged: false,
                text: this.props.feed.CarPlate || "",
                passD: {
                    LinkCode: this.state.code,
                    OrderStatus: this.state.code
                },
                status: this.state.code,
                intervalToCancel:0,
                timeoutToCancel:0,
                showSuccess:true,
                storeId:this.props.location.state.storeId
            };
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalToCancel);
        clearTimeout(this.state.timeoutToCancel);
    }

    componentDidUpdate() {
        this.redirect();
    }

    componentDidMount() {
        if(sessionStorage && !this.props.location.state) {
            const reqID = sessionStorage.getItem('reqID');
            if(reqID)
                history.push({pathname: `/${reqID}`});
        }
        this.redirect();
        if(this.props != undefined && this.state.storeId != undefined)
            this.props.getStoreDeliveryOptions(this.props.feed.LinkCode, this.state.storeId, this.state.preview);
        if (!this.state.preview && this.props.feed.CarPlateEnabled && this.props.feed.CarPlate.length > 0 && this.state.status < 300){
            this.setState({
                pType: 2
            });
            this.manageIntervals();
        }
        if(!this.props.isLogged && !this.props.loading && this.props.feed.OrderNumber && (this.props.feed.OrderNumber !== '#####' || this.props.feed.OrderNumber !== '######')){
            this.setState({
                isLogged: true
            });
            ai.appInsights.trackEvent({name:'Link ' + window.location.origin + '/'+this.props.feed.LinkCode + ' opened for order: ' + this.props.feed.OrderNumber});
        }
    }

    manageIntervals(){
        // @ts-ignore
        const intervalPeriod = window.app.env.RECHECK_WINDOW_INTERVAL;
        // @ts-ignore
        let mainIntInterval = window.app.env.API_CALL_INTERVAL;
        const timeout =  setTimeout(() => {
            this.redirectToManualCheck();
        }, intervalPeriod);
        this.setState({
            timeoutToCancel: timeout
        });
        const mainIntId = setInterval(() => {
            this.props.getOrder(this.props.feed.LinkCode);
        }, mainIntInterval);
        this.setState({
            intervalToCancel: mainIntId
        })
    }

    handleTextAreaChange = (event:any)=>{
        this.setState({
            text: event.target.value
        });
    };

    redirectToManualCheck = () => {
        const { CarPlateEnabled, CarPlate } = this.props.feed;
        if(CarPlateEnabled && CarPlate.length>0 && (this.state.pageType === "2" || this.state.pType == 2)){
        history.push({
            pathname:"/recheck",
            state:{data:this.props.feed, alreadyOpened:true}
        });}
    };

    onClick = (deliveryOption?: string) => {
      ai.appInsights.trackEvent({name: 'Link ' + window.location.origin + '/' + this.props.feed.LinkCode + ' for order: ' +
        this.props.feed.OrderNumber + ' entered text: ' + this.state.text + ' | delivery option: ' + deliveryOption});

      this.props.callUpdateOrder(this.props.feed.LinkCode, this.state.text, deliveryOption);
      this.props.getOrder(this.props.feed.LinkCode).then((resp: any) => {
        history.push({
          pathname: "/waiting",
          state: {
            order: this.props.feed,
            preview: this.state.preview,
            successChanged: false
          }
        });
      })
    };

    onClickForCarPlate = (deliveryOption?: string)=>{
        this.setState({
            showSuccess:false
        });
        clearInterval(this.state.intervalToCancel);
        clearTimeout(this.state.timeoutToCancel);

        ai.appInsights.trackEvent({name:'Link ' + window.location.origin + '/'+this.props.feed.LinkCode + ' for order: ' +
                this.props.feed.OrderNumber + ' entered text: ' + this.state.text + ' | delivery option: ' + deliveryOption});

        this.props.callUpdateCarPlates(this.props.feed.LinkCode, this.state.text, deliveryOption).then((r:any)=>{
            this.setState({
                pType: 2,
                text: r == undefined? this.state.text : r.data.CarPlate,
                showSuccess: r != undefined
            });
            this.manageIntervals();
        });
    };

    deliveryOptions = (styleCommon: React.CSSProperties, style: React.CSSProperties, onButtonClick: any) => {
        const optionStyle = {
            ...style,
            width: '100%',
            wordWrap: 'break-word'
        } as React.CSSProperties;

        const deliveryOptionSelectionText = this.props.deliveryOptions[0] && <label style={styleCommon}>{getOptionText(this.props.deliveryOptions[0])}</label>;

        const deliveryOptions = this.props.deliveryOptions.map((option: any, index: number) => {
            if(index > 0 )
            {
                return (<div key={index} style={{marginBottom: "10px"}}>
                        <Button disabled={this.state.preview || this.props.loading} value={getOptionText(option)} style={optionStyle} classList="btn-primary btn-lg"
                                onButtonClick={() => onButtonClick(option.DefaultLanguageText)}/>
                </div>)

            }
        });

        return <div>{deliveryOptionSelectionText}<div className="row" style={{margin: 0, justifyContent: 'center'}}><div>{deliveryOptions}</div></div></div>;
    }

    redirect(){
        let status = +this.props.feed.OrderStatus;
        if(this.state.preview){
            status = +this.state.status
        }
        if(status > orderStatuses.ReadyForDelivery && status <= orderStatuses.Intransit || status == orderStatuses.IntransitLocker){
            history.push({
                pathname:"/waiting",
                state:{order:this.props.feed, preview:this.state.preview}
            });
            return;
        }
        if(status == orderStatuses.UnQueued || status == orderStatuses.OngoingTakenByPicker){
            history.push({
                pathname:"/accepted",
                state:{data:this.state.passD, alreadyOpened:true, preview: this.state.preview}
            });
            return;
        }
        if(status == 696){
            history.push({
                pathname:"/recheck",
                state:{order:this.props.feed, preview:this.state.preview, cssStyle:this.props.cssStyles}
            });
            return;
        }
        if(status == orderStatuses.Removed){
            history.push({pathname:'/summary',state: {data: this.state.passD, OrderStatus:orderStatuses.Removed,cssStyle:this.props.cssStyles}})
            return;
        }
        if(status >= orderStatuses.Delivered && status != orderStatuses.Canceled && status != orderStatuses.Rejected && status!= orderStatuses.UnDelivered){
            history.push({pathname:'/summary',state: {data:this.state.passD, OrderStatus:orderStatuses.Delivered, cssStyle:this.props.cssStyles,pageType:this.state.pageType}})
            return;
        }
        if(status<orderStatuses.ReadyForDelivery || status== orderStatuses.UnDelivered){
            history.push({pathname:'/summary',state: {data:this.state.passD, OrderStatus:orderStatuses.LessThen200,cssStyle:this.props.cssStyles}})
            return;
        }
        if(status == orderStatuses.Canceled || status == orderStatuses.Rejected){
            history.push({pathname:'/summary',state: {data: this.state.passD, OrderStatus:orderStatuses.Canceled,cssStyle:this.props.cssStyles}})
            return;
        }

        if(this.props.error){
            history.push({pathname:'/error',state: {data: this.state.passD, OrderStatus:orderStatuses.LessThen200}})
            return;
        }
    }

    render() {
        const style200 = {
            background: this.props.cssStyles.ReadyForDelivery.ButtonBackGroundColor,
            borderColor: this.props.cssStyles.ReadyForDelivery.ButtonBackGroundColor,
            minWidth: 250,
            fontSize: 20,
            fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
            color: this.props.cssStyles.ReadyForDelivery.ButtonFontColor
        } as React.CSSProperties;

        const style200noCP = {
            background: this.props.cssStyles.EnterCarPlateNumber.ButtonBackGroundColor,
            borderColor: this.props.cssStyles.EnterCarPlateNumber.ButtonBackGroundColor,
            minWidth: 250,
            fontSize: 20,
            fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
            color: this.props.cssStyles.EnterCarPlateNumber.ButtonFontColor
        } as React.CSSProperties;

        const style200CP = {
            background: this.props.cssStyles.WaitingForArrival.ButtonBackGroundColor,
            borderColor: this.props.cssStyles.WaitingForArrival.ButtonBackGroundColor,
            minWidth: 250,
            fontSize: 20,
            fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
            color: this.props.cssStyles.WaitingForArrival.ButtonFontColor
        } as React.CSSProperties;

        const stylePlaceHolder = {
            position:"absolute",
            top:"50%;",
            marginTop:"-15px;",
            width:"100%",
            left:0
        } as React.CSSProperties;

        const styleCommon = {
            overflowWrap:"anywhere",
            fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
            color: this.props.cssStyles.CommonSettings.FontColor
        } as React.CSSProperties;

        const successMsg = {
            overflowWrap:"anywhere",
            fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
            color: "green"
        } as React.CSSProperties;

        //Page type 1 = EnterCarPlate number
        if(this.props.feed.CarPlateEnabled && this.props.feed.CarPlate.length===0 || this.state.pageType === "1"){
            return (
                <div className="container text-center">
                    <div className="row">
                        <div className="col-12" style={styleCommon}>
                            <h1>{t("EnterCarPlateNumber_TextInTheTopOfCommonText")}</h1>
                            <p>{t("CommonText_FirstLine")}</p>
                            <h3>{t("CommonText_SecondLine")}</h3>
                        </div>
                    </div>
                    <div className="row justify-content-md-center">
                        <div className="col-md-auto">
                            <div className="form-group">
                                <label style={styleCommon} htmlFor="comment">{t("EnterCarPlateNumber_InputFieldName")}</label>
                                <div>
                                    <textarea style={{minWidth:"260px"}} className="form-control" onChange={this.handleTextAreaChange} value={this.state.text}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.deliveryOptions.length == 0 ?
                    <div className="row">
                        <div className="col-12">
                            <Button disabled={this.state.preview || this.props.loading} value={t("EnterCarPlateNumber_ButtonText")} style={style200noCP} classList="btn-primary btn-lg"
                                    onButtonClick={() => this.onClickForCarPlate()}/>
                        </div>
                    </div>
                    : this.deliveryOptions(styleCommon, style200noCP, this.onClickForCarPlate)
                    }
                </div>
            )
            //Page type 2 = ChangeCarPlate number
        }else if(this.props.feed.CarPlateEnabled && this.props.feed.CarPlate.length>0 || this.state.pageType === "2") {
            return (
                <div className="container text-center">
                    <div className="row">
                        <div className="col-12" style={styleCommon}>
                            <h1>{t("WaitingForArrival_TextInTheTopOfCommonText")}</h1>
                            <p>{t("CommonText_FirstLine")}</p>
                            <h3>{t("CommonText_SecondLine")}</h3>
                        </div>
                    </div>
                    <div className="row justify-content-md-center">
                        <div className="col-md-auto">
                            <div className="form-group">
                                <label style={styleCommon} htmlFor="comment">{t("WaitingForArrival_InputFieldName")}</label>
                                <div>
                                <textarea style={{minWidth:"260px"}}
                                          className="form-control" onChange={this.handleTextAreaChange} value={this.state.text}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.deliveryOptions.length > 0 && this.state.showSuccess && <div><label style={successMsg}>{t("WaitingForArrival_InputFieldTemplate")}</label></div>}
                    {this.props.deliveryOptions.length == 0 ?
                    <div className="row justify-content-md-center" style={{marginTop: 0}}>
                        <div className="col-md-auto">
                            <div className="form-group">
                                {this.state.showSuccess && <label style={successMsg}>{t("WaitingForArrival_InputFieldTemplate")}</label>}
                                <div>
                                    <Button disabled={this.state.preview || this.props.loading} value={t("WaitingForArrival_ButtonText")} style={style200CP}
                                            classList="btn-primary btn-lg"
                                            onButtonClick={() => this.onClickForCarPlate()}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    : this.deliveryOptions(styleCommon, style200CP, this.onClickForCarPlate)
                    }
                </div>
            )
        }
        else {
            return (
                <div className="container text-center">
                    <div className="row">
                        <div className="col-12" style={styleCommon}>
                            <h1>{t("ReadyForDelivery_TextInTheTopOfCommonText")}</h1>
                            <p>{t("CommonText_FirstLine")}</p>
                            <h3>{t("CommonText_SecondLine")}</h3>
                        </div>
                    </div>
                    <div className="row justify-content-md-center">
                        <div className="col-md-auto">
                            <div className="form-group">
                                <label style={styleCommon} htmlFor="comment">{t("ReadyForDelivery_InputFieldName")}</label>
                                <div>
                                <textarea style={{minWidth:"260px"}}
                                          className="form-control" onChange={this.handleTextAreaChange} value={this.state.text}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.deliveryOptions.length == 0 ?
                    <div className="row">
                        <div className="col-12">
                            <Button disabled={this.state.preview || this.props.loading} value={t("ReadyForDelivery_ButtonText")} style={style200} classList="btn-primary btn-lg"
                                    onButtonClick={() => this.onClick()}/>
                        </div>
                    </div>
                    : this.deliveryOptions(styleCommon, style200, this.onClick)
                    }
                </div>
            )
        }
    }
}
